import React, { useState } from 'react';

import { getLabelFallback } from '@utils/utils';

interface Props {
    prescriptionFile: any;
    prescriptionManual: any;
    prescriptionDoctor: any;
    errorImgInner: boolean;
    prescriptionFileName: string;
}

const PrescriptionModal = ({ prescriptionFile, prescriptionManual, prescriptionDoctor, errorImgInner, prescriptionFileName }: Props): JSX.Element => {

    const [errorImg, setErrorImg] = useState(errorImgInner);
    
    return (
        <div className="prescription-modal">
            <div className="prescription-modal-file">
                <div className="prescription-modal-file-title">
                {!!prescriptionFile
                    ? getLabelFallback('YOUR_PRESCRIPTION_LABEL')
                    : !!prescriptionDoctor || !!prescriptionManual
                    ? getLabelFallback('PRESCRIPTION_STEP2_DOCTOR_TITLE_LABEL')
                    : getLabelFallback('PRESCRIPTION_MODAL_TITLE')}
                </div>
                {!!prescriptionFile ? (
                    !errorImg ? (
                        <img src={prescriptionFile} onError={event => setErrorImg(true)}></img>
                    ) : (
                        <div className="prescription-modal-file-error">
                        <div className="prescription-modal-file-error-name">
                            {prescriptionFileName}
                        </div>
                        <div className="prescription-modal-file-error-info">
                            {getLabelFallback('YOUR_PRESCRIPTION_ERROR_LABEL')}
                        </div>
                        </div>
                    )
                ) : !!prescriptionDoctor ? (
                    <div className="shipping-step-content-prescription-step2-buttons-doctor-selected">
                        <div className="modal-container-doctor-show-container">
                        <div className="modal-container-doctor-show-container-title">
                            <div className="modal-container-doctor-show-container-title-doctor-name">
                            {' '}
                            {getLabelFallback('DOCTOR_TABLE_DOCTOR_NAME_LABEL')}{' '}
                            </div>
                            <div className="modal-container-doctor-show-container-title-clinic-name">
                            {' '}
                            {getLabelFallback('DOCTOR_TABLE_CLINIC_NAME_LABEL')}{' '}
                            </div>
                            <div className="modal-container-doctor-show-container-title-address">
                            {' '}
                            {getLabelFallback('DOCTOR_TABLE_ADDRESS_LABEL')}{' '}
                            </div>
                        </div>
                        <div className="modal-container-doctor-show-container-all">
                            <div className="modal-container-doctor-show-container-all-row">
                            <div className="modal-container-doctor-show-container-all-row-doctor-name">
                                {' '}
                                {prescriptionDoctor.doctorName}{' '}
                            </div>
                            <div className="modal-container-doctor-show-container-all-row-clinic-name">
                                {' '}
                                {!!prescriptionDoctor.clinic
                                ? prescriptionDoctor.clinic
                                : ''}{' '}
                            </div>
                            <div className="modal-container-doctor-show-container-all-row-address">
                                {prescriptionDoctor.doctorAddress_p}
                                <span
                                className={
                                    'telephone' + (!prescriptionDoctor.isValidDoctor ? ' center' : '')
                                }
                                >
                                {prescriptionDoctor.doctorPhoneNumber}
                                </span>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                ) :( 
                    <>
                        <div className="shipping-step-content-prescription-step2-buttons-doctor-selected manual-input">
                        <div className="modal-container-doctor-show-container">
                            <div className="modal-container-doctor-show-container-title">
                            <div className="modal-container-doctor-show-container-title-space">
                                {' '}
                                {' '}
                            </div>
                            <div className="modal-container-doctor-show-container-title-sph">
                                {' '}
                                {getLabelFallback('MANUAL_TABLE_SPH_LABEL')}
                                {' '}
                            </div>
                            <div className="modal-container-doctor-show-container-title-cyl">
                                {' '}
                                {getLabelFallback('MANUAL_TABLE_CYL_LABEL')}
                                {' '}
                            </div>
                            <div className="modal-container-doctor-show-container-title-axis">
                                {' '}
                                {getLabelFallback('MANUAL_TABLE_AXIS_LABEL')}
                                {' '}
                            </div>
                            <div className="modal-container-doctor-show-container-title-add">
                                {' '}
                                {getLabelFallback('MANUAL_TABLE_ADD_LABEL')}
                                {' '}
                            </div>
                            <div className="modal-container-doctor-show-container-title-pd">
                                {' '}
                                {getLabelFallback('MANUAL_TABLE_PD_LABEL')}
                                {' '}
                            </div>
                            </div>
                            <div className="modal-container-doctor-show-container-all">
                            <div className='modal-container-doctor-show-container-all-row'>
                                <div className="modal-container-doctor-show-container-all-row-right">
                                <div className="modal-container-doctor-show-container-all-row-right-space">
                                    {getLabelFallback('MANUAL_TABLE_OD_LABEL')}
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-right-sph">
                                    {!!prescriptionManual.sph_od ? prescriptionManual.sph_od : '-'}
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-right-cyl">
                                    {!!prescriptionManual.cyl_od ? prescriptionManual.cyl_od : '-'}
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-right-axix">
                                    {!!prescriptionManual.ax_od ? prescriptionManual.ax_od : '-'}
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-right-add">
                                    {!!prescriptionManual.add_od ? prescriptionManual.add_od : '-'}
                                </div>
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-left">
                                <div className="modal-container-doctor-show-container-all-row-left-space">
                                    {getLabelFallback('MANUAL_TABLE_OS_LABEL')}
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-left-sph">
                                    {prescriptionManual.sph_os ? prescriptionManual.sph_os : '-'}
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-left-cyl">
                                    {prescriptionManual.cyl_os ? prescriptionManual.cyl_os : '-'}
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-left-axix">
                                    {prescriptionManual.ax_os ? prescriptionManual.ax_os : '-'}
                                </div>
                                <div className="modal-container-doctor-show-container-all-row-left-add">
                                    {prescriptionManual.add_os ? prescriptionManual.add_os : '-'}
                                </div>
                                </div>
                            </div>
                            <div className={"modal-container-doctor-show-container-all-row-right-pd" + (!!prescriptionManual.pupillaryDistance_left ? ' single' : '')}>
                            {!!prescriptionManual.pupillaryDistance ? prescriptionManual.pupillaryDistance : '-'}
                            </div>
                            {!!prescriptionManual.pupillaryDistance_left &&
                                <div className="modal-container-doctor-show-container-all-row-left-pd">
                                {prescriptionManual.pupillaryDistance_left}
                                </div>
                            }
                            </div>
                        </div>
                        </div>
                        {
                        prescriptionManual.prism_enabled && (
                            <div className="shipping-step-content-prescription-step2-buttons-doctor-selected manual-input prism">
                            <div className="modal-container-doctor-show-container">
                            <div className="modal-container-doctor-show-container-title">
                                <div className="modal-container-doctor-show-container-title-space">
                                {' '}
                                {' '}
                                </div>
                                <div className="modal-container-doctor-show-container-title-sph"
                                    dangerouslySetInnerHTML={{__html: getLabelFallback('MANUAL_TABLE_VPRISM_LABEL')}} 
                                >
                                </div>
                                <div className="modal-container-doctor-show-container-title-cyl">
                                {' '}
                                {getLabelFallback('MANUAL_TABLE_VPRISM_BASE_LABEL')}
                                {' '}
                                </div>
                                <div className="modal-container-doctor-show-container-title-axis"
                                    dangerouslySetInnerHTML={{__html: getLabelFallback('MANUAL_TABLE_VPRISM_LABEL')}}
                                >
                                </div>
                                <div className="modal-container-doctor-show-container-title-add">
                                {' '}
                                {getLabelFallback('MANUAL_TABLE_HPRISM_BASE_LABEL')}
                                {' '}
                                </div>
                                </div>
                                <div className="modal-container-doctor-show-container-all">
                                <div className='modal-container-doctor-show-container-all-row'>
                                    <div className="modal-container-doctor-show-container-all-row-right">
                                    <div className="modal-container-doctor-show-container-all-row-right-space">
                                        {getLabelFallback('MANUAL_TABLE_OD_LABEL')}
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-right-sph">
                                        {!!prescriptionManual.vprism_od ? prescriptionManual.vprism_od : '-'}
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-right-cyl">
                                        {!!prescriptionManual.vprism_base_od ? prescriptionManual.vprism_base_od : '-'}
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-right-axix">
                                        {!!prescriptionManual.hprism_od ? prescriptionManual.hprism_od : '-'}
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-right-add">
                                        {!!prescriptionManual.hprism_base_od ? prescriptionManual.hprism_base_od : '-'}
                                    </div>
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-left">
                                    <div className="modal-container-doctor-show-container-all-row-left-space">
                                        {getLabelFallback('MANUAL_TABLE_OS_LABEL')}
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-left-sph">
                                        {!!prescriptionManual.vprism_os ? prescriptionManual.vprism_os : '-'}
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-left-cyl">
                                        {!!prescriptionManual.vprism_base_os ? prescriptionManual.vprism_base_os : '-'}
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-left-axix">
                                        {!!prescriptionManual.hprism_os ? prescriptionManual.hprism_os : '-'}
                                    </div>
                                    <div className="modal-container-doctor-show-container-all-row-left-add">
                                        {!!prescriptionManual.hprism_base_os ? prescriptionManual.hprism_base_os : '-'}
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        )
                        }
                    </>
                )}
            </div>
        </div>
    );
};
export default PrescriptionModal;
